import { useDispatch } from "react-redux";
import PageLoadError from "../../../presentational/common/PageLoadError";
import { reinitialise } from "../../../../state/actions";

const ConnectedPageLoadError = props => {
  const dispatch = useDispatch();

  return (
    <PageLoadError reinitialise={() => dispatch(reinitialise())} {...props} />
  );
};

export default ConnectedPageLoadError;
